import { defineComponent as _defineComponent } from 'vue'
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";
import SvgTrash from "@/assets/icons/trash-dark.svg";

interface Props {
    variant?: 'outline' | 'ghost';
    size?: 'medium' | 'small' | 'extraSmall';
    contentVariant?: 'iconOnly' | 'withIcon';
    isDisabled?: boolean;
    text?: string;
    isActive?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TrashButton',
  props: {
    variant: { default: 'outline' },
    size: { default: 'medium' },
    contentVariant: { default: 'withIcon' },
    isDisabled: { type: Boolean },
    text: { default: 'Удалить' },
    isActive: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as { variant: 'outline' | 'ghost', size: 'medium' | 'small' | 'extraSmall', contentVariant: 'iconOnly' | 'withIcon', isDisabled?: boolean, text: string, isActive?: boolean }





return { __sfc: true,props, emit, BaseButtonV2, SvgTrash }
}

})